
const partnersDescription = [
    {
        id: 1,
        title: 'Nasi Partnerzy',
        content: 'Współpraca jest fundamentem działań naszej fundacji. Dzięki zaangażowaniu instytucji, firm i osób, które podzielają nasze wartości, możemy realizować projekty mające realny wpływ na społeczność i otoczenie. Każdy z naszych partnerów wnosi coś wyjątkowego — wiedzę, doświadczenie, wsparcie lub energię, która pozwala nam działać skuteczniej i tworzyć trwałe, pozytywne zmiany.',
        end: 'Razem budujemy więcej. Razem możemy wszystko.',
    },
    {
        id: 2,
        title: 'Zostań naszym Partnerem',
        content: 'Razem możemy zrobić więcej! Jeśli chcesz, aby Twoja marka była częścią inspirujących inicjatyw i realnych zmian, dołącz do grona naszych partnerów. Wspierając fundację, zyskujesz widoczność, budujesz pozytywny wizerunek i współtworzysz projekty, które mają znaczenie.',
        end: 'Dołącz do nas — stwórzmy wspólnie coś, co zostanie na długo.',
    },
];

export default partnersDescription;